import useApiRequest from "@/lib/hooks/use-request";
import { CreatePipelineRequestDto, PipelineDetailsResponseDto } from "@/lib/interfaces/pipelines";
import { Button } from "@/ui-components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/ui-components/ui/form";
import { Input } from "@/ui-components/ui/input";
import { zodResolver } from "@hookform/resolvers/zod";
import { Crosshair } from "lucide-react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { z } from "zod";

const PipelineEditor = ({
  item,
  withoutRedirect,
  onSubmitDone,
}: {
  item?: PipelineDetailsResponseDto;
  withoutRedirect?: boolean;
  onSubmitDone?: (id: string, title: string) => void;
}) => {
  const navigate = useNavigate();
  const { apiRequest } = useApiRequest();

  const pipelineSchema = z.object({
    title: z
      .string()
      .min(1, { message: "Titel ist erforderlich" })
      .max(100, { message: "Titel muss weniger als 100 Zeichen lang sein" }),
  });

  type PipelineFormSchema = z.infer<typeof pipelineSchema>;

  const form = useForm<PipelineFormSchema>({
    resolver: zodResolver(pipelineSchema),
    defaultValues: {
      title: "",
    },
  });

  const onSubmit = async (data: PipelineFormSchema) => {
    const req: CreatePipelineRequestDto = {
      title: data.title,
    };
    const res = await apiRequest<PipelineDetailsResponseDto>("pipelines", "POST", {
      body: req,
      toast: { toastText: "Pipeline erfolgreich erstellt" },
    });

    if (res.data) {
      if (onSubmitDone) {
        onSubmitDone(res.data._id, res.data.title);
      }
      if (!withoutRedirect) {
        navigate(`/pipelines/${res.data._id}`);
      }
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-5 h-full">
        <div className="space-y-6">
          <div className="space-y-4">
            <div className="flex flex-col gap-2">
              <FormLabel className="font-medium">Title:*</FormLabel>
              <FormField
                control={form.control}
                name="title"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <Input {...field} placeholder="Title" />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
          </div>
        </div>
        <Button type="submit" variant="default" className="text-white font-bold flex items-center gap-4 w-fit self-end">
          <Crosshair className="h-4 w-4" />
          <span>{item ? "Pipeline aktualisieren" : "Pipeline erstellen"}</span>
        </Button>
      </form>
    </Form>
  );
};

export default PipelineEditor;
